import { Field } from "@deligoo/ui"
import { unwrapResult } from "@reduxjs/toolkit"
import dayjs from "dayjs"
import { useState } from "react"
import { toast } from "react-toastify"

import { useAppDispatch, useAppSelector } from "@/App"
import { ConfirmModal } from "@/components/ConfirmModal"
import { requestMoveOrderToBuffer } from "@/store/orders"
import { selectCurrentTeamStats } from "@/store/teamsStats"
import { Order } from "@/types"

type MoveOrderToBufferModalProps = {
  orderId: Order["id"]
  handleClose: () => void
}

export const MoveOrderToBufferModal = ({ orderId, handleClose }: MoveOrderToBufferModalProps) => {
  const { buffering_time } = useAppSelector(selectCurrentTeamStats) || {}

  const [pickupAt, setPickupAt] = useState(
    dayjs()
      .add(10 + Number(buffering_time), "minutes")
      .format("HH:mm")
  )
  const [isLoading, setLoading] = useState(false)

  const dispatch = useAppDispatch()

  async function handleMoveToBuffer() {
    const toastSettings = {
      toastId: "moveToBuffer",
      updateId: "moveToBuffer",
    }

    setLoading(true)

    const res = await dispatch(requestMoveOrderToBuffer({ orderId, body: { pickup_at: pickupAt } })).then(unwrapResult)

    if (res.ok) {
      toast.success(`Zlecenie zostało zwrócone do bufora.`, toastSettings)
    } else {
      toast.error(`Nie udało się zwrócić zlecenia do bufora. Spróbuj ponownie później.`, toastSettings)
    }

    setLoading(false)
    handleClose()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setPickupAt(e.currentTarget.value)

  return (
    <ConfirmModal
      title="Cofnij do bufora"
      isLoading={isLoading}
      handleConfirm={handleMoveToBuffer}
      handleClose={handleClose}
    >
      <Field
        label="Czas kompletacji"
        name="pickup_at"
        inputProps={{
          id: "pickup_at",
          value: pickupAt,
          onChange: handleChange,
          type: "time",
          plain: true,
          required: true,
          min: dayjs().format("HH:mm"),
          autoFocus: true,
        }}
      />
    </ConfirmModal>
  )
}
